export default __webpack_public_path__ + "static/media/txt.a23b12a2.svg";